export const NUMBER = 'number';
export const STRING = 'string';
export const RANGE = 'range';
export const VALUE = 'value';
